<template>
    <div>
        <p>This is about</p>
    </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/About.vue